import { defineComponent as _defineComponent } from 'vue'
import NavigationBar from "@/components/shared/NavigationBar.vue";
import { inject, onMounted, ref } from "vue";
import RoadEventRow from "./RoadEventRow.vue";
import EmptyContent from "@/components/shared/EmptyContent.vue";
import { IRoadEvent } from "@/domain/entities/roadEvent";
import { useLineStore } from "@/stores/lineStore";
import { PROVIDE_KEY_SHOW_ERROR_MODAL, ShowErrorModal } from "@/types";


const __default__ = {
  name: "RoadEventListModal",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  routeUid: {
    type: String,
    required: true,
  },
},
  emits: ["onClickClose"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const lineStore = useLineStore();

const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;

const emitOnClickClose = () => {
  emit("onClickClose");
};

const handleError = (title: string, result: any) => {
  showErrorModal(
    title,
    result.errorMessage,
    result.resultCode,
    result.errorTime
  );
};

/** 무한 스크롤 기능 */
const currentPage = ref(0);
const currentLimit = 20;
const totalCount = ref(0);

const contentWrapper = ref();

const handleScroll = () => {
  if (!contentWrapper.value) return;

  const nearBottom =
    contentWrapper.value.clientHeight + contentWrapper.value.scrollTop >
    contentWrapper.value.scrollHeight - 200;

  if (!nearBottom) return;
  if (roadEventList.value.length >= totalCount.value) return;
  getRoadEventList();
};

const roadEventList = ref<IRoadEvent[]>([]);
const isLoading = ref(false);

const getRoadEventList = async () => {
  // 이미 로딩 중이면 중복 호출 방지
  if (isLoading.value) return;

  isLoading.value = true;
  const currentOffset = currentPage.value * currentLimit;
  const fetchResult = await lineStore.getRoadEventList(
    props.routeUid,
    currentOffset,
    currentLimit
  );
  isLoading.value = false;

  if (!fetchResult.isSuccess) {
    handleError("교통정보 조회 오류", fetchResult);
    return;
  }

  if (!fetchResult.data) return;
  totalCount.value = fetchResult.data.totalCount;
  if (fetchResult.data.list.length === 0) return;
  roadEventList.value = [...roadEventList.value, ...fetchResult.data.list];
  currentPage.value += 1;
};

onMounted(async () => {
  await getRoadEventList();
});

const __returned__ = { props, emit, lineStore, showErrorModal, emitOnClickClose, handleError, currentPage, currentLimit, totalCount, contentWrapper, handleScroll, roadEventList, isLoading, getRoadEventList, NavigationBar, RoadEventRow, EmptyContent }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})